import React, { ReactElement } from 'react';

import { THorizontalLineProperties } from './horizontal-line.types';
import { StyledHorizontalLine } from './horizontal-line.styled';

export function HorizontalLine({
    color = 'indigo',
    className,
    ...otherProperties
}: THorizontalLineProperties): ReactElement {
    return (
        <StyledHorizontalLine
            color={color}
            className={className}
            {...otherProperties}
        />
    );
}
